import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class EntBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: '0',
    };

    handleMouseOver = e => {
        const val = e.currentTarget.attributes['data-index'].value;

        this.setState({
            current: val,
        });
    };

    render() {
        const { current } = this.state;
        const {
            content: { entTopic, entTitle, entList, entVideoList, entListAd, entBoxData, entVideoBoxData },
        } = this.props;

        return (
            <div id="entNewsList" className={styles.ent_box}>
                <Chip id="50087" type="struct" title="娱乐栏标题" groupName="娱乐栏" content={entTopic}>
                    <NewsTopic handleMouseOver={this.handleMouseOver} />
                </Chip>
                <Chip
                    id="75058"
                    type="recommend"
                    title="娱乐栏头条"
                    groupName="娱乐栏"
                    content={entTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <div className={`${current === '0' ? '' : styles.hide}`}>
                    <Chip
                        id="75059"
                        type="recommend"
                        title="娱乐栏娱乐新闻列表"
                        groupName="娱乐栏"
                        content={entList}
                        translate="handleNewsContentData"
                        position="relative">
                        <NewsList isList ad={entListAd} />
                    </Chip>
                </div>
                <div className={`${current === '0' ? styles.hide : ''}`}>
                    <Chip
                        id="75140"
                        type="recommend"
                        title="娱乐栏视频新闻列表"
                        groupName="娱乐栏"
                        content={entVideoList}
                        translate="handleNewsContentData"
                        position="relative">
                        <NewsList isList />
                    </Chip>
                </div>
                <div className={`${current === '0' ? '' : styles.hide}`}>
                    <Chip
                        id="75060"
                        type="recommend"
                        title="娱乐栏娱乐新闻图片盒"
                        groupName="娱乐栏"
                        content={entBoxData}
                        translate="handleNewsContentData"
                        position="relative">
                        <NewsBox />
                    </Chip>
                </div>
                <div className={`${current === '0' ? styles.hide : ''}`}>
                    <Chip
                        id="75141"
                        type="recommend"
                        title="娱乐栏视频盒"
                        groupName="娱乐栏"
                        content={entVideoBoxData}
                        translate="handleNewsContentData"
                        position="relative">
                        <NewsBox />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(EntBox);
